export default __webpack_public_path__ + "static/media/pattern.8b566c74.svg";